export default __webpack_public_path__ + "static/media/034-clipboard.d8c07fe1.svg";